import Rest from '@services/Rest';

/**
 * @typedef {CancelSubscriptionService}
 */
export default class CancelSubscriptionService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/subscription'
}
